// extracted by mini-css-extract-plugin
module.exports = {"root":"OBTAccordionGroup_root__1Milh","child":"OBTAccordionGroup_child__2b-fv","selected":"OBTAccordionGroup_selected__g1YNK"};